import axiosInstance  from "@/utils/axiosConfig"
import { setObjectLocalStorageCondition } from "@/utils/localStorageExpire"

export default {
	state: () => ({
		actionToken: ""
	}),
	mutations: {
		SET_ACTION_TOKEN(state, token) {
			console.log(token)
			state.actionToken = token
		}
	},
	actions: {
		async REGISTER_USER({ commit }, registryData) {
			const {
				data: {
					data: { actionToken },
					msg
				}
			} = await axiosInstance.post("/auth/register", {
				...registryData
			})
			console.log(actionToken)

			commit("SET_ACTION_TOKEN", actionToken)

			return msg
		},
		async ACTIVATE_USER(context, activationData) {
			const { data } = await axiosInstance.post(
				"/auth/register/activate-account",
				{
					...activationData
				}
			)
			setObjectLocalStorageCondition(data.tokens, data.success)
			return data
		},
		async RESEND_ACTIVATION_CODE(context, actionToken) {
			const {
				data
			} = await axiosInstance.post(
				"/auth/register/activate-account/resend",
				{ actionToken }
			)
			return data
		}
	},
	namespaced: true
}
